import { render, staticRenderFns } from "./PercentileChart.vue?vue&type=template&id=52e6ca03&"
import script from "./PercentileChart.vue?vue&type=script&lang=ts&"
export * from "./PercentileChart.vue?vue&type=script&lang=ts&"
import style0 from "./PercentileChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports